import { render, staticRenderFns } from "./PrivateClassDetails.vue?vue&type=template&id=65455b30"
import script from "./PrivateClassDetails.vue?vue&type=script&lang=js"
export * from "./PrivateClassDetails.vue?vue&type=script&lang=js"
import style0 from "./PrivateClassDetails.vue?vue&type=style&index=0&id=65455b30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports